import dataTable from "./data.json";
export default {
  column: [
    {
      headerName: "No.",
      field: "id",
      width: 150,
      filter: true,
    },
    {
      headerName: "Name",
      field: "name",
      width: 175,
      filter: true,
    },

    {
      headerName: "Email",
      field: "email",
      filter: true,
      width: 250,
    },
    {
      headerName: "Phone",
      field: "phone",
      filter: true,
      width: 150,
    },
    {
      headerName: "Joining Date",
      field: "joining_date",
      filter: true,
      width: 150,
    },
    {
      headerName: "Details",
      field: "id_user",
      filter: true,
      width: 100,

      cellRendererFramework: "iconDetail",
    },
    {
      headerName: "Status",
      field: "status",
      filter: true,
      width: 125,
      cellRenderer: (params) => {
        if (params.value) {
          return "Publish";
        } else {
          return "Banned";
        }
      },
    },
    {
      headerName: "Manage",
      field: "manage",
      filter: true,
      width: 150,
      cellRendererFramework: "iconDelete",
    },
  ],
  api: dataTable,
};
